import { useEffect, useState } from "react";
import ViewerEvents from "events/ViewerEvents";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function CircularProgressWithBackdrop() {
    const [open, setOpen] = useState(false);
    const [isBusy, setIsBusy] = useState(false);

    const handleClose = () => {
        console.log("Click on view")
    };

    useEffect(() => {
        var setBusy = (status: any) => {
            setIsBusy(status.isBusy);
            setOpen(status.isBusy && !ViewerEvents.newScene)
            //setOpen(isBusy)
            console.log("Isbusy : " + status.isBusy)
            console.log("NewScene : " + !ViewerEvents.newScene)
        };
       
        ViewerEvents.on("busy", setBusy);
        return () => {
            console.log("Remove Busy listener : " + isBusy)
            ViewerEvents.removeEventListener("busy", setBusy);
        };
    });
 

    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
                onClick={handleClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}
